var t;!function(t){t.TEXT_PLAIN="text/plain",t.TEXT_HTML="text/html",t.TEXT_URI_LIST="text/uri-list"}(t||(t={}));export{t as DataTransferFormat};
//# sourceMappingURL=useDragReorder.constants.js.map
